import Tolls from "../../../../../services/toll";
import {cpfCnpj} from "../../../../../validators/cpfCnpj";
import messageDialog from "../../../../../components/message-dialog";

export default {
  props: ['aggregate','transportadorRntrc', 'nxtStep'],
  data() {
    return {
      loading: undefined,
      rntrcDocument: undefined,
      rntrcOwnerName: undefined,
      enableRNTRC: false,
      msgError: undefined,
    }
  },

  mounted () {
    if (!this.aggregate.companyName)
      this.aggregate.companyName = this.aggregate.personName +' '+ this.aggregate.personLastName;
  },

  methods:{
    showRNTRC() {
      this.enableRNTRC = true;
    },

    cancelRNTRC() {
      this.enableRNTRC = false;
      this.rntrcDocument = '';
      this.rntrcOwnerName = '';
      this.msgError = undefined;
    },

    validateDocument() {

      if (!this.rntrcOwnerName) {
        this.msgError = "Favor informar Nome/Razão Social.";
        return;
      }

      if (!this.rntrcDocument) {
        this.msgError = 'Favor informar CPF/CNPJ.';
        return;
      }

      if (!cpfCnpj.validate(this.rntrcDocument)) {
        this.msgError = "Documento inválido!";
        return;
      }


      this.loading = Tolls.getVehicleDataVp(this.aggregate.plate, this.rntrcDocument).then(response => {
        this.vehicle = response;
        this.enableRNTRC = false;
        const rntrcValidado = response && response.rntrc && !response.rntrc.includes("RNTRC");
        if (rntrcValidado){
          if (this.rntrcOwnerName) {
            this.transportadorRntrc.nome = this.rntrcOwnerName.toUpperCase();
            this.aggregate.nomeTransportador = this.transportadorRntrc.nome;
          } else {
            this.transportadorRntrc.nome = "";
            this.aggregate.nomeTransportador = "";
          }
          if (this.rntrcDocument) {
            this.transportadorRntrc.documento = this.rntrcDocument;
            this.aggregate.taxpayerTransportador = this.transportadorRntrc.documento ;
          }
        }

        this.rntrcDocument = '';
        this.rntrcOwnerName = '';
        this.msgError = undefined;

        if (rntrcValidado){
          messageDialog.show({
            title: 'Sucesso',
            message: 'Documento validado com sucesso.',
            type: 'OK'
          });
        } else {
          messageDialog.show({
            title: 'Falha validação',
            message: response.rntrc,
            type: 'OK'
          });
        }
        this.$emit('nxtStep');
      }).catch(err => {
        console.log(err)

        this.msgError = 'Favor entrar em contato com o suporte.';
        if(err.data.status.code !== 9990)
            this.msgError = err.data.status.message;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/account/aggregate/modal/toll-ticket/transportador-rntrc.js